import { IGetState, TBoardId } from '../types/types';
import { Dispatch, ThunkAction } from '../types/actions';
import { getBoard } from '../store/model/selectors/getBoardById';
import { getMessages, root } from '../store/constants';
import {
    EBoardSetting
} from '../view/react_components/aside_panel/boardDetails/details/TabDetails/components/TabDetails/types';

export const openBoardForm = (
    boardId: TBoardId,
    openSetting: EBoardSetting
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const board = getBoard(getState(), boardId);
        if (board) {
            root.App.controller.asidePanel.showBoard(boardId, openSetting);
        } else {
            root.App.controller.showError(getMessages().getText('error.record.not_found'));
        }
    };
    return action;
}
